export const getShortAddress = ({ address, street_number, subpremise, route, }) => {
    if (address)
        return address;
    let newAddressString = `${!!street_number ? `${street_number}${!!route ? ` ${route}` : ''}` : ''}`;
    newAddressString += (!!street_number || !!route) && subpremise ? ', ' : '';
    newAddressString += !!subpremise ? `${subpremise}` : '';
    return newAddressString;
};
export const getLongAddress = (shortAddress, { city, province, postal_code, country }) => {
    const addressInfos = [
        shortAddress,
        city,
        province,
        postal_code,
        country,
    ].filter((value) => !!(value === null || value === void 0 ? void 0 : value.length));
    return addressInfos.join(', ');
};
export function getComponent(address, type) {
    const component = address.find((c) => c.types.includes(type));
    return component ? component.long_name : '';
}
export function getShortComponent(address, type) {
    const component = address.find((c) => c.types.includes(type));
    return component ? component.short_name : '';
}
